export class Tchgpwd {
    USER_ID: string;
    LOGIN_PASSWORD: string; 
        
  }